import React from 'react'

import { Field } from 'formik'

import { Form, Col, Button } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

import * as TablaPersonalizadaService from 'services/tablasPersonalizadas.service'

import { NuevoActualizarTablaPersonalizadaModal } from 'sharedComponents/modals'
import { EliminarTablaPersonalizadaModal } from 'sharedComponents/modals'

const IdGrupoContableComprasFormGroup = ({
  values,
  setValues,
  iError,
  iTouched,
  fIsSubmitting,
  gruposContablesCompras,
  actualizarGruposContablesCompras
}) => {
  const [mostrarSeleccionarCuentaModal, setMostrarSeleccionarCuentaModal] = React.useState(false)
  const [mostrarEliminarCuentaModal, setMostrarEliminarCuentaModal] = React.useState(false)
  const [dataGrupoContable, setDataGrupoContable] = React.useState(null)

  React.useEffect(() => {
    if (gruposContablesCompras.length === 1) {
      values.cuentaContableCompra = gruposContablesCompras[0]._id
      setValues(values)
    }
  }, [gruposContablesCompras, values, setValues])

  const onSuccess = React.useCallback(async () => {
    actualizarGruposContablesCompras()
    setMostrarSeleccionarCuentaModal(false)
  }, [actualizarGruposContablesCompras])

  const clickEliminarGrupoContable = React.useCallback(() => {
    const idTablaPersonalizada = gruposContablesCompras.find(x => x._id === values.cuentaContableCompra).id
    TablaPersonalizadaService.getAsEdicion(idTablaPersonalizada).then(({ data }) => {
      setDataGrupoContable(data)
      setMostrarEliminarCuentaModal(true)
    })
  }, [values, gruposContablesCompras])

  return (
    <>
      <Form.Group>
        <Form.Label text='COMPRAS' htmlFor='select-gContablesCompras' sm={2} md={3} lg={2} alignRightAt='sm' />
        <Col sm={10} md={9} lg={10}>
          <Form.InputGroup>
            <Field name='cuentaContableCompra'>
              {({ field }) => (
                <Form.Select
                  {...field}
                  disabled={fIsSubmitting}
                  isInvalid={iTouched && iError}
                  id='select-gContablesCompras'
                >
                  <option value=''>Seleccionar</option>
                  {gruposContablesCompras &&
                    gruposContablesCompras.map((val, key) => (
                      <option key={key} value={val._id}>
                        {val.nombre}
                      </option>
                    ))}
                </Form.Select>
              )}
            </Field>
            <Form.InputGroup.Append>
              <Button onClick={() => setMostrarSeleccionarCuentaModal(true)}>+</Button>
              <Button className='bg-danger border border-danger' onClick={() => clickEliminarGrupoContable()}>
                -
              </Button>
            </Form.InputGroup.Append>
          </Form.InputGroup>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
      {mostrarSeleccionarCuentaModal && (
        <NuevoActualizarTablaPersonalizadaModal
          handleClose={e => setMostrarSeleccionarCuentaModal(false)}
          show={mostrarSeleccionarCuentaModal}
          modalData={{}}
          onSuccess={onSuccess}
          tipoTabla={TiposTablaPersonalizadaConstant.GRUPOCONTABLECOMPRA}
        />
      )}
      {mostrarEliminarCuentaModal && (
        <EliminarTablaPersonalizadaModal
          handleClose={e => setMostrarEliminarCuentaModal(false)}
          show={mostrarEliminarCuentaModal}
          modalData={dataGrupoContable}
          onSuccess={onSuccess}
          tipoTabla={TiposTablaPersonalizadaConstant.GRUPOCONTABLECOMPRA}
        />
      )}
    </>
  )
}

export default React.memo(IdGrupoContableComprasFormGroup)
